var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import styled, { css } from 'styled-components';
import React, { useRef, useState, useEffect, useCallback } from 'react';
import { useSpring, animated } from '@react-spring/web';
import { theme, breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ArrowDownIcon, MinusIcon, PlusIcon } from '@shapeable/icons';
import { useLang } from '../hooks/use-lang';
var cls = classNames('svg-canvas');
export var SvgCanvasDefaultProps = {
  isInteractive: true,
  zoomFactor: 1.25,
  downloadScaleFactor: 4,
  initialZoom: 1,
  maxZoom: 4,
  minZoom: 0.25,
  width: 100,
  height: 100,
  springConfig: {
    friction: 10,
    tension: 100,
    mass: 0.4
  },
  fadeColor: 'brightWarm',
  fadeSize: 8
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n  "], ["\n    position: relative;\n  "])))
});
var CanvasStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: block;\n\n    ", "\n\n    height: 100%;\n    width: 100%;\n  "], ["\n    display: block;\n\n    ", "\n\n    height: 100%;\n    width: 100%;\n  "])), function (_a) {
    var isInteractive = _a.isInteractive;
    return isInteractive && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      cursor: grab;  \n      &:active {\n        cursor: grabbing;\n      }\n    "], ["\n      cursor: grab;  \n      &:active {\n        cursor: grabbing;\n      }\n    "])));
  })
});
var ControlsStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    top: ", ";\n    right: ", ";\n    display: flex;\n    gap: ", ";\n    z-index: 90;\n  "], ["\n    position: absolute;\n    top: ", ";\n    right: ", ";\n    display: flex;\n    gap: ", ";\n    z-index: 90;\n  "])), theme.UNIT(3), theme.UNIT(4), theme.UNIT(1.5))
});
var ZoomInStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ZoomOutStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var BaseFadeStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    position: absolute;\n    z-index: 50;\n  "], ["\n    position: absolute;\n    z-index: 50;\n  "])))
});
var TopFadeStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", ";\n    left: 0;\n    ", "\n  "], ["\n    ", ";\n    left: 0;\n    ", "\n  "])), BaseFadeStyles, function (_a) {
    var fadeColor = _a.fadeColor,
      fadeSize = _a.fadeSize;
    return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      height: ", "px;\n      width: 100%;\n      background: linear-gradient(to top, ", "00 0%, ", "FF 100%);\n    "], ["\n      height: ", "px;\n      width: 100%;\n      background: linear-gradient(to top, ", "00 0%, ", "FF 100%);\n    "])), fadeSize, theme.COLOR(fadeColor), theme.COLOR(fadeColor));
  })
});
var BottomFadeStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", ";\n    ", "\n  "], ["\n    ", ";\n    ", "\n  "])), BaseFadeStyles, function (_a) {
    var fadeColor = _a.fadeColor,
      fadeSize = _a.fadeSize;
    return css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      top: calc(100% - ", "px);\n      height: ", "px;\n      width: 100%;\n      background: linear-gradient(to bottom, ", "00 0%, ", "FF 100%);\n    "], ["\n      top: calc(100% - ", "px);\n      height: ", "px;\n      width: 100%;\n      background: linear-gradient(to bottom, ", "00 0%, ", "FF 100%);\n    "])), fadeSize, fadeSize, theme.COLOR(fadeColor), theme.COLOR(fadeColor));
  })
});
var LeftFadeStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    ", ";\n    top: 0;\n    height: 100%;\n    ", "\n  "], ["\n    ", ";\n    top: 0;\n    height: 100%;\n    ", "\n  "])), BaseFadeStyles, function (_a) {
    var fadeColor = _a.fadeColor,
      fadeSize = _a.fadeSize;
    return css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      width: ", "px;\n      background: linear-gradient(to left, ", "00 0%, ", "FF 100%);\n    "], ["\n      width: ", "px;\n      background: linear-gradient(to left, ", "00 0%, ", "FF 100%);\n    "])), fadeSize, theme.COLOR(fadeColor), theme.COLOR(fadeColor));
  })
});
var RightFadeStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    ", ";\n    top: 0;\n    right: 0;\n    height: 100%;\n    ", "\n  "], ["\n    ", ";\n    top: 0;\n    right: 0;\n    height: 100%;\n    ", "\n  "])), BaseFadeStyles, function (_a) {
    var fadeColor = _a.fadeColor,
      fadeSize = _a.fadeSize;
    return css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      width: ", "px;\n      background: linear-gradient(to right, ", "00 0%, ", "FF 100%);\n    "], ["\n      width: ", "px;\n      background: linear-gradient(to right, ", "00 0%, ", "FF 100%);\n    "])), fadeSize, theme.COLOR(fadeColor), theme.COLOR(fadeColor));
  })
});
var DownloadStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    cursor: pointer;\n    ", ";\n  "], ["\n    cursor: pointer;\n    ", ";\n  "])), theme.REMOVE_BUTTON_STYLE())
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Canvas: styled(animated.svg).attrs(cls.attr('canvas'))(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), CanvasStyles),
  Controls: styled.div.attrs(cls.attr('controls'))(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  Button: styled.button(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  ZoomInIcon: styled(PlusIcon)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ZoomInStyles),
  ZoomOutIcon: styled(MinusIcon)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), ZoomOutStyles),
  DownloadIcon: styled(ArrowDownIcon)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), DownloadStyles),
  TopFade: styled.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), TopFadeStyles),
  BottomFade: styled.div(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), BottomFadeStyles),
  LeftFade: styled.div(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), LeftFadeStyles),
  RightFade: styled.div(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), RightFadeStyles)
};
export var SvgCanvas = function (props) {
  var className = props.className,
    children = props.children,
    zoomFactor = props.zoomFactor,
    initialZoom = props.initialZoom,
    initialY = props.initialY,
    initialX = props.initialX,
    width = props.width,
    height = props.height,
    fadeColor = props.fadeColor,
    fadeSize = props.fadeSize,
    springConfig = props.springConfig,
    downloadScaleFactor = props.downloadScaleFactor,
    isInteractive = props.isInteractive,
    bottomFadeSize = props.bottomFadeSize,
    topFadeSize = props.topFadeSize,
    leftFadeSize = props.leftFadeSize,
    rightFadeSize = props.rightFadeSize;
  var svgRef = useRef(null);
  var t = useLang();
  var initialWidth = width / initialZoom;
  var initialHeight = height / initialZoom;
  var x = initialX !== null && initialX !== void 0 ? initialX : (width - initialWidth) / 2;
  var y = initialY !== null && initialY !== void 0 ? initialY : (height - initialHeight) / 2;
  // 140.25576061134203 27.681931411717546 516.0960000000001 516.0960000000001
  var initialViewBox = props.initialViewBox || {
    x: x,
    y: y,
    width: initialWidth,
    height: initialHeight,
    zoom: initialZoom
  };
  var _a = __read(useState(initialViewBox), 2),
    viewBox = _a[0],
    setViewBox = _a[1];
  var _b = __read(useState(null), 2),
    panStart = _b[0],
    setPanStart = _b[1];
  var prevMousePosition = useRef(null);
  var _c = __read(useState(null), 2),
    initialPinchDistance = _c[0],
    setInitialPinchDistance = _c[1];
  var _d = __read(useState(null), 2),
    wheelTimeout = _d[0],
    setWheelTimeout = _d[1];
  var _e = __read(useSpring(function () {
      return {
        viewBox: [viewBox.x, viewBox.y, viewBox.width, viewBox.height],
        config: springConfig
      };
    }), 2),
    animatedViewBox = _e[0].viewBox,
    setSpring = _e[1];
  useEffect(function () {
    setSpring({
      viewBox: [viewBox.x, viewBox.y, viewBox.width, viewBox.height],
      immediate: !!panStart
    });
  }, [viewBox, setSpring, panStart]);
  var handleMouseDown = function (event) {
    setPanStart({
      x: event.clientX,
      y: event.clientY
    });
    prevMousePosition.current = {
      x: event.clientX,
      y: event.clientY
    };
  };
  var handleMouseMove = function (event) {
    if (!panStart) return;
    var svgElement = svgRef.current;
    if (!svgElement) return;
    var svgRect = svgElement.getBoundingClientRect();
    var dx = (event.clientX - prevMousePosition.current.x) * (viewBox.width / svgRect.width);
    var dy = (event.clientY - prevMousePosition.current.y) * (viewBox.height / svgRect.height);
    setViewBox(function (prev) {
      return __assign(__assign({}, prev), {
        x: prev.x - dx,
        y: prev.y - dy
      });
    });
    prevMousePosition.current = {
      x: event.clientX,
      y: event.clientY
    };
  };
  var handleWheel = React.useCallback(function (event) {
    event.preventDefault();
    if (!svgRef.current) return;
    if (wheelTimeout) {
      clearTimeout(wheelTimeout);
    }
    var rect = svgRef.current.getBoundingClientRect();
    var delta = Math.sign(event.deltaY);
    var wheelZoomFactor = delta > 0 ? 1.05 : 0.95;
    var mouseX = (event.clientX - rect.left) / rect.width * viewBox.width + viewBox.x;
    var mouseY = (event.clientY - rect.top) / rect.height * viewBox.height + viewBox.y;
    if (viewBox.zoom * wheelZoomFactor > props.maxZoom || viewBox.zoom * wheelZoomFactor < props.minZoom) return;
    zoom(wheelZoomFactor, mouseX, mouseY);
    setWheelTimeout(setTimeout(function () {
      setWheelTimeout(null);
    }, 50)); // Throttle time
  }, [viewBox, wheelTimeout]);
  var handleMouseUp = function (event) {
    event.preventDefault();
    event.stopPropagation();
    setPanStart(null);
  };
  var handleTouchStart = function (event) {
    if (event.touches.length === 2) {
      // const dx = event.touches[0].clientX - event.touches[1].clientX;
      // const dy = event.touches[0].clientY - event.touches[1].clientY;
      // const distance = Math.sqrt(dx * dx + dy * dy);
      // setInitialPinchDistance(distance);
    } else if (event.touches.length === 1) {
      setPanStart({
        x: event.touches[0].clientX,
        y: event.touches[0].clientY
      });
    }
  };
  var handleTouchMove = function (event) {
    event.preventDefault();
    if (event.touches.length === 2 && initialPinchDistance !== null) {
      var dx = event.touches[0].clientX - event.touches[1].clientX;
      var dy = event.touches[0].clientY - event.touches[1].clientY;
      var distance = Math.sqrt(dx * dx + dy * dy);
      var scaleFactor_1 = initialPinchDistance / distance;
      setViewBox(function (prev) {
        return {
          x: prev.x + prev.width * (scaleFactor_1 - 1) / 2,
          y: prev.y + prev.height * (scaleFactor_1 - 1) / 2,
          width: prev.width * scaleFactor_1,
          height: prev.height * scaleFactor_1,
          zoom: prev.zoom * scaleFactor_1
        };
      });
    } else if (panStart) {
      var svgElement = svgRef.current;
      if (!svgElement) return;
      var svgRect = svgElement.getBoundingClientRect();
      var dx_1 = (event.touches[0].clientX - panStart.x) * (viewBox.width / svgRect.width);
      var dy_1 = (event.touches[0].clientY - panStart.y) * (viewBox.height / svgRect.height);
      setViewBox(function (prev) {
        return __assign(__assign({}, prev), {
          x: prev.x - dx_1,
          y: prev.y - dy_1
        });
      });
      setPanStart({
        x: event.touches[0].clientX,
        y: event.touches[0].clientY
      });
    }
  };
  var handleTouchEnd = function (event) {
    if (event.touches.length < 2) {
      setPanStart(null);
      // setInitialPinchDistance(null);
    }
  };
  var zoomIn = function (centerX, centerY) {
    return zoom(1 / zoomFactor, centerX, centerY);
  };
  var zoomOut = function (centerX, centerY) {
    return zoom(zoomFactor, centerX, centerY);
  };
  var zoom = function (factor, centerX, centerY) {
    var cx = centerX !== null && centerX !== void 0 ? centerX : viewBox.x + viewBox.width / 2;
    var cy = centerY !== null && centerY !== void 0 ? centerY : viewBox.y + viewBox.height / 2;
    var newZoom = viewBox.zoom * factor;
    if (newZoom > props.maxZoom || newZoom < props.minZoom) return;
    setViewBox(function (prev) {
      return {
        x: cx - (cx - prev.x) * factor,
        y: cy - (cy - prev.y) * factor,
        width: prev.width * factor,
        height: prev.height * factor,
        zoom: prev.zoom * factor
      };
    });
  };
  var handleDoubleClick = function (event) {
    if (!svgRef.current) return;
    var rect = svgRef.current.getBoundingClientRect();
    var clickX = (event.clientX - rect.left) / rect.width * viewBox.width + viewBox.x;
    var clickY = (event.clientY - rect.top) / rect.height * viewBox.height + viewBox.y;
    if (event.altKey) {
      zoomOut(clickX, clickY); // Zoom out
    } else {
      zoomIn(clickX, clickY); // Zoom in
    }
  };
  useEffect(function () {
    var handleMouseMoveWrapper = function (event) {
      return handleMouseMove(event);
    };
    var handleMouseUpWrapper = function (event) {
      return handleMouseUp(event);
    };
    document.addEventListener('mousemove', handleMouseMoveWrapper);
    document.addEventListener('mouseup', handleMouseUpWrapper);
    return function () {
      document.removeEventListener('mousemove', handleMouseMoveWrapper);
      document.removeEventListener('mouseup', handleMouseUpWrapper);
    };
  }, [panStart]);
  useEffect(function () {
    var svg = svgRef.current;
    if (svg) {
      // svg.addEventListener('wheel', handleWheel, { passive: false });
      svg.addEventListener('touchmove', handleTouchMove);
      svg.addEventListener('touchend', handleTouchEnd);
      svg.addEventListener('touchcancel', handleTouchEnd);
    }
    return function () {
      if (svg) {
        // svg.removeEventListener('wheel', handleWheel);
        svg.removeEventListener('touchmove', handleTouchMove);
        svg.removeEventListener('touchend', handleTouchEnd);
        svg.removeEventListener('touchcancel', handleTouchEnd);
      }
    };
  }, [panStart]);
  var downloadSvgAsPng = useCallback(function (svgElement, fileName, scaleFactor) {
    if (scaleFactor === void 0) {
      scaleFactor = 4;
    }
    var width = svgElement.clientWidth;
    var height = svgElement.clientHeight;
    // Create a canvas with the scaled width and height
    var canvas = document.createElement("canvas");
    canvas.width = width * scaleFactor;
    canvas.height = height * scaleFactor;
    var context = canvas.getContext("2d");
    if (context) {
      // Scale the context by the given factor
      context.scale(scaleFactor, scaleFactor);
      // Serialize the SVG into a string
      var svgString = new XMLSerializer().serializeToString(svgElement);
      // Create a Blob from the SVG string
      var svgBlob = new Blob([svgString], {
        type: "image/svg+xml;charset=utf-8"
      });
      // Create a URL for the Blob
      var url_1 = URL.createObjectURL(svgBlob);
      // Create an Image element
      var img_1 = new Image();
      img_1.onload = function () {
        // Draw the SVG image onto the canvas at the original size
        context.drawImage(img_1, 0, 0, width, height); // Use original width and height here
        // Convert the canvas to a PNG data URL
        var pngDataUrl = canvas.toDataURL("image/png");
        // Create a link element to trigger the download
        var downloadLink = document.createElement("a");
        downloadLink.href = pngDataUrl;
        downloadLink.download = "".concat(fileName, ".png");
        // Trigger the download
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        // Revoke the object URL to free memory
        URL.revokeObjectURL(url_1);
      };
      // Set the Image src to the SVG Blob URL
      img_1.src = url_1;
    }
  }, [svgRef]);
  var download = function () {
    if (!svgRef.current) return;
    downloadSvgAsPng(svgRef.current, 'dataviz.png', downloadScaleFactor);
  };
  var iconColors = {
    fill: 'light',
    background: 'brightWarm',
    hover: {
      fill: 'dark',
      background: 'brightWarm'
    }
  };
  return React.createElement(My.Container, {
    isInteractive: isInteractive,
    className: cls.name(className)
  }, React.createElement(My.TopFade, {
    fadeSize: topFadeSize !== null && topFadeSize !== void 0 ? topFadeSize : fadeSize,
    fadeColor: fadeColor
  }), React.createElement(My.BottomFade, {
    fadeSize: bottomFadeSize !== null && bottomFadeSize !== void 0 ? bottomFadeSize : fadeSize,
    fadeColor: fadeColor
  }), React.createElement(My.RightFade, {
    fadeSize: rightFadeSize !== null && rightFadeSize !== void 0 ? rightFadeSize : fadeSize,
    fadeColor: fadeColor
  }), isInteractive && React.createElement(My.Controls, null, React.createElement(My.Button, {
    title: t('Zoom In'),
    onClick: function () {
      return zoomIn();
    }
  }, React.createElement(My.ZoomInIcon, {
    size: 28,
    colors: iconColors
  })), React.createElement(My.Button, {
    title: t('Zoom Out'),
    onClick: function () {
      return zoomOut();
    }
  }, React.createElement(My.ZoomOutIcon, {
    size: 28,
    colors: iconColors
  })), React.createElement(My.Button, {
    title: t('Download'),
    onClick: function () {
      return download();
    }
  }, React.createElement(My.DownloadIcon, {
    size: 28,
    colors: iconColors
  }))), React.createElement(My.Canvas, {
    isInteractive: isInteractive,
    ref: svgRef,
    viewBox: animatedViewBox.to(function (x, y, width, height) {
      return "".concat(x, " ").concat(y, " ").concat(width, " ").concat(height);
    }),
    onMouseDown: isInteractive ? handleMouseDown : null,
    onDoubleClick: isInteractive ? handleDoubleClick : null,
    onTouchStart: isInteractive ? handleTouchStart : null
  }, children));
};
SvgCanvas.defaultProps = SvgCanvasDefaultProps;
export default SvgCanvas;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28;